/**
 * Server-safe column ids + table display defaults for DEFAULT_USER_DISPLAY_PREFERENCES.
 * Keep in sync with ./columns.tsx.
 */

export const teachers_column_display_seeds: {
    id: string;
    defaultDisplayPreferences: {
        order: number;
        size: number;
        visible: boolean;
        pinned: boolean;
        displayAs: "number" | "string" | "date" | "other";
    };
}[] = [
    {
        id: "firstName",
        defaultDisplayPreferences: {
            order: 3,
            size: 130,
            visible: true,
            displayAs: "string",
            pinned: true,
        },
    },
    {
        id: "lastName",
        defaultDisplayPreferences: {
            order: 2,
            size: 150,
            visible: true,
            displayAs: "string",
            pinned: true,
        },
    },
    {
        id: "defaultStatus",
        defaultDisplayPreferences: {
            order: 1,
            size: 110,
            visible: true,
            displayAs: "other",
            pinned: false,
        },
    },
    {
        id: "email",
        defaultDisplayPreferences: {
            order: 4,
            size: 200,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "skills",
        defaultDisplayPreferences: {
            order: 5,
            size: 200,
            visible: true,
            displayAs: "other",
            pinned: false,
        },
    },
    {
        id: "sites",
        defaultDisplayPreferences: {
            order: 5,
            size: 200,
            visible: true,
            displayAs: "other",
            pinned: false,
        },
    },
    {
        id: "homePhoneNumber",
        defaultDisplayPreferences: {
            order: 6,
            size: 150,
            visible: false,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "cellPhoneNumber",
        defaultDisplayPreferences: {
            order: 7,
            size: 150,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "socialSecurityNumber",
        defaultDisplayPreferences: {
            order: 8,
            size: 200,
            visible: false,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "birthName",
        defaultDisplayPreferences: {
            order: 9,
            size: 200,
            visible: false,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "birthDate",
        defaultDisplayPreferences: {
            order: 10,
            size: 200,
            visible: false,
            displayAs: "date",
            pinned: false,
        },
    },
    {
        id: "birthPlace",
        defaultDisplayPreferences: {
            order: 11,
            size: 200,
            visible: false,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "address",
        defaultDisplayPreferences: {
            order: 12,
            size: 300,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "isValidatedByAdmins",
        defaultDisplayPreferences: {
            order: 13,
            size: 120,
            visible: true,
            displayAs: "other",
            pinned: false,
        },
    },
    {
        id: "isApprovedByUniversity",
        defaultDisplayPreferences: {
            order: 14,
            size: 120,
            visible: true,
            displayAs: "other",
            pinned: false,
        },
    },
    {
        id: "isASearcher",
        defaultDisplayPreferences: {
            order: 15,
            size: 120,
            visible: true,
            displayAs: "other",
            pinned: false,
        },
    },
    {
        id: "key",
        defaultDisplayPreferences: {
            order: 16,
            size: 150,
            visible: false,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "fileAdmissionDate",
        defaultDisplayPreferences: {
            order: 17,
            size: 150,
            visible: false,
            displayAs: "date",
            pinned: false,
        },
    },
    {
        id: "degree",
        defaultDisplayPreferences: {
            order: 18,
            size: 150,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "worksFor",
        defaultDisplayPreferences: {
            order: 19,
            size: 150,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "matricule",
        defaultDisplayPreferences: {
            order: 20,
            size: 150,
            visible: false,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "job",
        defaultDisplayPreferences: {
            order: 21,
            size: 150,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "nationality",
        defaultDisplayPreferences: {
            order: 22,
            size: 150,
            visible: false,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "organizationName",
        defaultDisplayPreferences: {
            order: 23,
            size: 150,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "structure",
        defaultDisplayPreferences: {
            order: 24,
            size: 150,
            visible: false,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "favoriteOf",
        defaultDisplayPreferences: {
            order: 28,
            size: 150,
            visible: true,
            displayAs: "number",
            pinned: false,
        },
    },
    {
        id: "attendances",
        defaultDisplayPreferences: {
            order: 25,
            size: 150,
            visible: true,
            displayAs: "number",
            pinned: false,
        },
    },
    {
        id: "contracts",
        defaultDisplayPreferences: {
            order: 27,
            size: 150,
            visible: true,
            displayAs: "number",
            pinned: false,
        },
    },
    {
        id: "cdcs",
        defaultDisplayPreferences: {
            order: 26,
            size: 150,
            visible: true,
            displayAs: "number",
            pinned: false,
        },
    },
    {
        id: "createdAt",
        defaultDisplayPreferences: {
            order: 29,
            size: 200,
            visible: false,
            displayAs: "date",
            pinned: false,
        },
    },
];
